import React, { useEffect, useState } from "react";
import Device from "../../constants/Device";
import { apiRequestWithRetry } from "src/services/ClientSideAPIService";
import { RenderHomePageSchema } from "helpers/Helper";
import { useAppContext } from "@components/Provider";
import PostSearch from "./PostSearch";
import RecentlyPublishedSection from "./RecentlyPublishedSection";
import DealsCarousel from "@components/HomePageStories/DealsCarousel";
import NewsletterV2 from "@components/NewsletterV2/NewsletterV2";
import NewsletterModalV2 from "@components/NewsletterV2/NewsletterV2Modal";

import styles from "./EBBHomePageV2.module.css";
import "./EBBHomePageV2.css";

const EBBHomepageV2 = (props) => {
  props = props.HomeData;
  let { data, siteId, hideEBBNl, host, isMobile, isTablet } = useAppContext(),
    [contentHomePageData, recentPostsData] = props.data,
    { post } = contentHomePageData.Index || {},
    { posts: recentPosts, siteLogo } = recentPostsData.RecentPosts || {},
    { SiteSettings } = data || {},
    { components: postComponents } = post,
    pageBuilderOptions = {
      deviceSize: Device.DESKTOP,
      Newsletter_Settings: SiteSettings.newsletter_settings,
      homePage: true,
    };
  // Seems like following is redundant and was commented as part of development of https://openroadmedia.atlassian.net/browse/ORMTECH-3268

  // let queryParam = "";
  // if (props.PageUrl) {
  //   let url = props.PageUrl ? new URL(props.PageUrl) : "";
  //   queryParam = url && url.searchParams.get("utm_source");
  // }

  const [deals, setDeals] = useState("");
  const [dealsURL] = SiteSettings.site_header.nav_items.filter((el) => el.isTopDealUrl);

  useEffect(() => {
    (async () => {
      let url = dealsURL?.url.replace("/", "") || "";
      if (siteId && url) {
        const postData = await apiRequestWithRetry(`post/${siteId}?slug=${url}`);
        let dealsData = postData?.post?.components.filter((el) => el.type === "book-listicle-info");
        if (dealsData && dealsData.length > 0) {
          dealsData.length = 1;
          setDeals(dealsData);
        }
      }
    })();
  }, []);

  let nonClosableModal = false;

  const renderPostComponent = (component, index) => {
    let { type, props, name } = component;
    const renderSubtitle = ["bookClubPicks"];
    let renderComponent;
    switch (type) {
      case "post-search":
        renderComponent = (
          <PostSearch
            {...props}
            name={name}
            siteId={siteId}
            key={`component-${index}`}
            renderSubtitle={renderSubtitle.includes(name)}
          />
        );
        break;
      case "newsletter-v2":
        nonClosableModal = props?.nonClosableModalProps?.nonClosableModal;
        renderComponent = hideEBBNl ? (
          ""
        ) : props.subComponentType === "inline" ? (
          <NewsletterV2
            classNames={["ebb-home-nl", !hideEBBNl ? "ebb-home-nl-hide" : ""].join(" ")}
            {...props}
            {...pageBuilderOptions}
            key={`newsletter-${index}`}
            header={"<p>Get great deals on bestselling ebooks!</p>"}
            newsletterSubCopy={"Never pay full price again."}
            newsletterSubFooter={
              "<p>Or <a href='/login?redirect=/'>login</a> to see your personal book deal!</p>"
            }
            newsletterAddImage={
              props?.modalProps?.nonClosableModal ? "" : `${process.env.S3_IMAGE_URL}/plane-nl.png`
            }
            disableRenderButton={true}
            post_type={post?.post_type}
          />
        ) : (
          <NewsletterModalV2
            classNames={["ebb-home-nl", !hideEBBNl ? "ebb-home-nl-hide" : ""].join(" ")}
            {...props}
            {...pageBuilderOptions}
            key={`newsletter-${index}`}
            disableRenderButton={true}
          />
        );
        break;
      default:
        break;
    }

    return renderComponent;
  };

  return (
    <>
      <div
        className={[
          styles["homepage-wrapper"],
          !isMobile && !isTablet && styles["homepage-wrapper-margin-top"],
        ].join(" ")}
        style={{
          "--hideEBBNl": hideEBBNl ? 1 : 0,
          "--section-backimage": `url(${process.env.S3_IMAGE_URL}/bookclub.png)`,
          "--nonClosableModal": nonClosableModal ? 1 : 0,
        }}
      >
        <div className={[styles["ebb-homepage"], "ebb-homepage"].join(" ")}>
          {postComponents?.length > 0 && postComponents.map(renderPostComponent)}
          {/* Just Published */}
          <RecentlyPublishedSection
            siteId={siteId}
            recentPosts={recentPosts}
            defaultSiteLogo={siteLogo}
          />
          {/* Deals Carousel Section */}
          <DealsCarousel
            title={"Our Top Deal"}
            footer={{
              title: "Not a good fit?",
              link: {
                url: "/account/profile",
                text: "Update Preferences",
              },
            }}
            deals={deals}
            hideEBBNl={hideEBBNl}
          />
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={RenderHomePageSchema(SiteSettings, post, host, siteId)}
      />
    </>
  );
};

export default EBBHomepageV2;
